import React from 'react';
import { Users, Layers } from 'lucide-react';
import { Button } from './ui/button';

// Read-only crew list for one day of a multi-day job. Crew are edited on the allocation block.
export const DayCrewReadOnly = ({ crew, workerTypes, operators, onEditBlock, title, testIdPrefix }) => (
  <div className="space-y-3 p-3 bg-muted/50 rounded-lg border" data-testid={`${testIdPrefix}-section`}>
    <div className="flex items-center gap-2">
      <Users className="h-4 w-4 text-[#ffd108]" />
      <span className="label-overline">{title}</span>
    </div>
    {crew.length === 0 ? (
      <p className="text-xs text-muted-foreground" data-testid={`${testIdPrefix}-empty`}>No crew on this day.</p>
    ) : (
      <ul className="space-y-1">
        {crew.map(wa => (
          <li key={wa.id} className="text-sm text-foreground" data-testid={`${testIdPrefix}-row-${wa.id}`}>
            <span className="text-muted-foreground">{workerTypes.find(wt => wt.id === wa.worker_type_id)?.name || 'Worker'}:</span>{' '}
            {operators.find(o => o.id === wa.operator_id)?.name || 'Unassigned'}
          </li>
        ))}
      </ul>
    )}
    <p className="text-xs text-muted-foreground">Crew are set on the allocation block.</p>
    <Button type="button" variant="outline" size="sm" onClick={onEditBlock} data-testid={`${testIdPrefix}-edit-block-btn`}>
      <Layers className="h-3.5 w-3.5 mr-1.5" />Edit crew in allocation block
    </Button>
  </div>
);
